module.exports = __webpack_public_path__ + "components/flag/static/square/gs-1858b63b9f63da44769f33b4a842a7d1.svg";